
import * as React from "react";
import Header from "../../Header";
import Footer from "../../Footer";
import { IRestaurantListItem } from "../../../interfaces/IRestaurant";
import { IXhrUrls } from "./EditRestaurant";
import { Api } from "../../../lib/Api";
import EditRestaurant from "./EditRestaurant";
import LoaderComp from "../../../../avernus/loader/source/LoaderComp";

interface IRestaurantListProps {
    setUrl        : any
    urlPrefix     : string
}

interface IRestaurantListState {
    items   : Array<IRestaurantListItem>
    openedId: number
    version : number
    filter  : string
}

interface IGetListResult {
    items:Array<IRestaurantListItem>
}

export default class RestaurantList extends React.Component<IRestaurantListProps, IRestaurantListState>{

    private defaultUploadImage:string;
    private idName:string;
    private xhrUrls:IXhrUrls;

    constructor(props:IRestaurantListProps){
        super(props);
        this.defaultUploadImage = 'img/restaurant/profile_uploader_icon.png';
        this.idName             = 'restaurant';
        this.xhrUrls = {
            init:           this.props.urlPrefix + '/restaurant/init',
            get:            this.props.urlPrefix + '/restaurant/get',
            list:           this.props.urlPrefix + '/restaurant/getList',
            remove:         this.props.urlPrefix + '/restaurant/remove',
            addOrModify:    this.props.urlPrefix + '/restaurant/addOrModify'
        }
        this.state = {
            version : 0,
            items   : null,
            openedId: null,
            filter  : ''
        };
        this.init();
    }

    private init(){
        Api.call(this.xhrUrls.list, {}, (result:IGetListResult)=>{
            this.setState({
                items: result.items,
                version: (this.state.version + 1)
            });
        });
    }

    private addNewUserBtnClickHandler(evt): void {
        evt.preventDefault();
        this.setState({
            openedId: 0
        });
    }

    private editUserBtnClickHandler(evt, id:number): void {
        evt.preventDefault();
        this.setState({
            openedId: id
        });
    }

    private removeUserBtnClickHandler(evt, id:number, userName:string): void {
        evt.preventDefault();
        this.setState({
            openedId: null
        }, () =>{
            // remove
            if (window.confirm("Are you sure want to delete this \""+userName+"\" restaurant?")) {
            Api.call(this.xhrUrls.remove, { id: id }, (result)=>{
                this.init(); // reload
            });
        }
        });
    }

    private changeFilterHandler(evt): void {
        evt.preventDefault();
        this.setState({
            filter: evt.target.value
        });
    }

    private filter(items:Array<IRestaurantListItem>):Array<IRestaurantListItem>{
        if ( this.state.filter.trim() === '' ) {
            return items;
        }
        let filterStr = this.state.filter.toLowerCase();
        return items.filter(item => (item.name.toLowerCase().indexOf(filterStr)>-1));
    }


    render() {
        let title = 'Restaurants';
        if ( this.state.openedId !== null ) {
            title = 'Add new restaurant';
            if ( this.state.openedId > 0 ) {
                title = "Modify restaurant"
            }
        }
        return (
            <>
                <Header
                    title = {title}
                    setUrl={this.props.setUrl}
                ></Header>
                <div className="container content_section">

                    { this.state.openedId !== null?<EditRestaurant
                        key={this.idName+'_form_'+this.state.openedId}
                        urlPrefix={this.props.urlPrefix}
                        xhrUrls={this.xhrUrls}
                        defaultUploadImage={this.defaultUploadImage}
                        id={this.state.openedId}
                        idName={this.idName}
                        changed={ (close) => {
                            if ( close === true ) {
                                this.setState({
                                        openedId: null
                                }, () =>{
                                    this.init();
                                });
                            }else{
                                this.init();
                            }

                        } }
                    />:this.RestaurantListSection() }

                </div>
                <Footer setUrl={this.props.setUrl}></Footer>
			</>
        );
    }

    private RestaurantListSection() {
        return <section className={this.idName+"_list"}>
            {this.state.items === null ? <div className="loading_row">
                <LoaderComp show={true} />
            </div> : <>
                    <div className="form-row" style={{padding: '10px'}}>
                        <div className="col sfc">
                            <input type="text" className="s-form-control" placeholder="Search..." value={ this.state.filter } onChange={ (e) => this.changeFilterHandler(e) } />
                        </div>
                    </div>
                    {this.filter(this.state.items).map((item, index) => {
                        return <div className="row" key={index} id={this.idName+'_row_'+item.id}>
                            <div className="col-3 align-self-center" onClick={e => this.editUserBtnClickHandler(e, item.id)}>
                                <img className="img-fluid" src={item.img} width="90px" height="90px" />
                            </div>
                            <div className="col align-self-center" onClick={e => this.editUserBtnClickHandler(e, item.id)}>
                                <strong>{item.name}</strong>
                            </div>
                            <div className="col-2 align-self-center" onClick={e => this.editUserBtnClickHandler(e, item.id)}>
                                <a className="btn btn-link table_edit_btn" role="button">
                                    <i className="icon ion-edit" />
                                </a>
                            </div>
                            <div className="col-2 align-self-center table_remove_btn" onClick={e => this.removeUserBtnClickHandler(e, item.id, item.name)}>
                                <a className="btn btn-link" role="button">
                                    <i className="icon ion-trash-a" />
                                </a>
                            </div>
                        </div>;
                    })}

                    <div className="row mt35">
                        <div className="col-10 offset-1">
                            <button className="green_btn btn-block" id={"add_new_"+this.idName+"_btn"} onClick={(e) => { this.addNewUserBtnClickHandler(e); } }>
                                ADD NEW RESTAURANT
                            </button>

                        </div>
                    </div>
                </>}
        </section>;
    }
}
